<template>
  <el-dialog
    :title="$t('downShopHouseOutManage.chooseOrder')"
    :visible.sync="dialogVisible"
    width="70%"
    @close="handleClose"
  >
    <el-table
      :data="orderList"
      style="width: 100%"
      border
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        width="55"
      ></el-table-column>
      <el-table-column prop="orderId" label="订单编号" align="center"></el-table-column>
      <el-table-column prop="createTime" label="创建时间" align="center"></el-table-column>
      <el-table-column prop="state" label="状态" align="center">
        <template slot-scope="scope">
          {{ formatState(scope.row.state) }}
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      layout="prev, pager, next"
      :total="total"
      :page-size="pageSize"
      @current-change="handleCurrentChange"
    ></el-pagination>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="handleConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { queryInoutOrder } from '@/api/goods/downShopHouseOutManageApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'ChooseInoutOrder',
  data() {
    return {
      dialogVisible: false,
      orderList: [],
      selectedOrders: [],
      total: 0,
      pageSize: 10,
      queryParams: {
        state: '',
        shopId: ''
      }
    }
  },
  methods: {
    open(params) {
      this.queryParams.state = params.state
      this.queryParams.shopId = getShopId()
      this.dialogVisible = true
      this.getOrderList()
    },
    async getOrderList() {
      try {
        const res = await queryInoutOrder({
          ...this.queryParams,
          page: 1,
          row: this.pageSize
        })
        this.orderList = res.data
        this.total = res.total
      } catch (error) {
        console.error('获取订单列表失败:', error)
      }
    },
    handleSelectionChange(val) {
      this.selectedOrders = val
    },
    handleConfirm() {
      if (this.selectedOrders.length === 0) {
        this.$message.warning('请选择订单')
        return
      }
      this.$emit('chooseInoutOrder', this.selectedOrders[0])
      this.dialogVisible = false
    },
    handleClose() {
      this.selectedOrders = []
    },
    formatState(state) {
      // 这里可以添加状态格式化逻辑
      return state
    },
    handleCurrentChange(val) {
      console.log(val)
    }
  }
}
</script>